<template>
  <v-data-table :headers="headers" :items="listFailures" class="elevation-1">
    <template v-slot:top>
      <v-toolbar flat dark color="primary">
        <v-toolbar-title>Erori transmitere SMS</v-toolbar-title>
      </v-toolbar>
    </template>

    <template v-slot:item.createdAt="{ item }">
      <span>{{new Date(item.createdAt).toLocaleString()}}</span>
    </template>

    <template v-slot:item.action="{ item }">
      <v-tooltip left >
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="mr-2" @click="editItem(item)" v-bind="attrs" v-on="on">login</v-icon>
        </template>
        <span>Vezi client</span>
      </v-tooltip>

      <v-tooltip left >
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="mr-2" @click="solveItem(item)" v-bind="attrs" v-on="on">done</v-icon>
        </template>
        <span>Marcheaza ca rezolvat</span>
      </v-tooltip>

    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'Failures',
  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Eroare',
          align: 'center',
          value: 'errorMessage',
          sortable: true,
        },
        {
          text: 'Telefon',
          align: 'center',
          value: 'phone',
          sortable: true,
        },
        {
          text: 'Data',
          align: 'center',
          value: 'createdAt',
          sortable: true,
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        },
      ],
      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  created() {
    this.$store.dispatch('failures/getFailures');
  },
  computed: {
    listFailures() {
      return this.$store.state.failures.all;
    },
  },
  methods: {
    editItem(item) {
      this.$router.push({
        name: 'Editare client',
        params: { id: item.clientId },
      });
    },
    solveItem(item) {
      if (window.confirm('Sunteti sigur?')) {
        this.$store.dispatch('failures/solve', item.id);
      }
    },
  },
};
</script>
